import React from 'react';
import PropTypes from 'prop-types';
import './index.less';

import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../shared/form-elements/select/field';
import Modal from  '../../../shared/modal';

const Form = ({ handleSubmit, ...props }) => (
	<div className='text-email-form'>
		<form
			className='ui-form'
			onSubmit={handleSubmit(props.sendTestEmail)}
		>
			<div className='ui-form__element'>
				<Field
					name='email'
					placeholder={props.intl('Email')}
					multi={false}
					component={SelectField}
					options={props.adminsLookup}
				/>
			</div>
			<div className='ui-form__element'>
				<button className='ui-btn ui-btn-primary'>
					{props.intl('Send test')}
				</button>
				<button
					className='ui-btn ui-btn-secondary'
					onClick={(e) => {
						e.preventDefault();
						props.toggleTestEmailModal();
					}}
				>
					{props.intl('Cancel')}
				</button>
			</div>
		</form>
	</div>
);

Form.propTypes = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	sendTestEmail: PropTypes.func,
	toggleTestEmailModal: PropTypes.func,
	adminsLookup: PropTypes.func
};

const Main = props => (
	<Modal
		className='modal-overlay__content test-email-modal'
		title={props.intl('Send test email')}
		body={Form(props)}
		isOpen={props.showTestEmailModal}
		onClose={props.toggleTestEmailModal}
	/>
);

Main.propTypes = {
	intl: PropTypes.func,
	showTestEmailModal: PropTypes.bool,
	toggleTestEmailModal: PropTypes.func
};

export default reduxForm({ form: 'mailingsSendTestEmailForm' })(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/components/test-email-modal/index.js